module.exports = __webpack_public_path__ + "static/elan-coupe-s2-7e270b499b447091beee9cfa1de6c1b5.png";